export const SMB = 'small_medium_business';
export const ENTERPRISE = 'enterprise';
